import { render, staticRenderFns } from "./InfoItem.vue?vue&type=template&id=43c628e2&scoped=true&"
import script from "./InfoItem.vue?vue&type=script&lang=js&"
export * from "./InfoItem.vue?vue&type=script&lang=js&"
import style0 from "../../Style/info-item.scss?vue&type=style&index=0&id=43c628e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c628e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43c628e2')) {
      api.createRecord('43c628e2', component.options)
    } else {
      api.reload('43c628e2', component.options)
    }
    module.hot.accept("./InfoItem.vue?vue&type=template&id=43c628e2&scoped=true&", function () {
      api.rerender('43c628e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/DmVisualizer/Components/ChangeInfo/InfoItem.vue"
export default component.exports